"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var clsx_1 = tslib_1.__importDefault(require("clsx"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.Icon = function (_a) {
    var name = _a.name, className = _a.className, rest = tslib_1.__rest(_a, ["name", "className"]);
    return (react_1.default.createElement(StyledIcon, tslib_1.__assign({ role: "img", "aria-label": name }, rest, { className: clsx_1.default('dds-icons icon', className) }), name));
};
var StyledIcon = styled_components_1.default.i(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  font-size: 2.4rem;\n"], ["\n  font-size: 2.4rem;\n"])));
exports.Icon.displayName = 'FOS__Icon';
exports.default = exports.Icon;
var templateObject_1;
